module.exports = __webpack_public_path__ + "img/portrait.8917afe6.png";